import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/content";

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 bg-slate-50"
    >
      <div className="mx-auto max-w-4xl px-6 md:px-10 lg:px-12">
        <div className="text-center mb-14 md:mb-16">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-sky-700">
            <span className="w-6 h-px bg-sky-600" /> FAQ
          </span>
          <h2 className="font-display mt-4 text-4xl sm:text-5xl font-semibold text-slate-900 leading-[1.05]">
            Häufige Fragen.
          </h2>
          <p className="mt-5 text-slate-600 text-base md:text-lg leading-relaxed">
            Kurz und direkt beantwortet. Fehlt etwas? Rufen Sie uns gerne an.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="rounded-2xl border border-slate-200 bg-white p-2 md:p-4 shadow-sm"
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-slate-100 last:border-0"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display text-base md:text-lg font-semibold text-slate-900 px-4 py-5 hover:no-underline hover:text-sky-700"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="px-4 pb-5 text-slate-600 leading-relaxed text-[15px]"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
